<template>
	<div class="report-wrap">
		<!-- <p class="tips">服务时效至2022年12月31日…</p> -->
		<div class="list-wrap">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list
					v-show="reportList.length > 0"
					v-model="loading"
					:offset="150"
					:finished="finished"
					:finished-text="finishedText"
					@load="onLoad"
				>
					<div
						class="group-item"
						:class="{ 'group-fail': item.status == 3 }"
						@click="toDetail(item)"
						v-for="(item, index) in reportList"
						:key="index"
					>
						<span
							class="group-state"
							:class="{
								running: item.status == 1,
								finish: item.status == 2,
								fail: item.status == 3,
							}"
							>{{ item.status | filterOptions(stateList) }}</span
						>
						<img
							class="group-item-icon"
							:src="getImgUrl(item.fileType)"
							alt=""
						/>
						<div class="group-item-info">
							<p class="name">
								机构名称：{{ item.originalName }}
							</p>
							<p class="time">上传时间：{{ item.createTime }}</p>
							<p class="fail-desc" v-show="item.status == 3">
								{{ item.failMessage }}
							</p>
						</div>
					</div>
				</van-list>
				<div class="no-data" v-show="reportList.length == 0 && flag">
					<img
						class="img-icon"
						src="@/assets/images/m-report/no-data.png"
					/>
					<p class="desc">暂无体检报告</p>
				</div>
			</van-pull-refresh>
		</div>
		<div class="h-button">
			<button class="btn-item left" @click="toJumpDoc">
				查看健康档案
			</button>
			<button class="btn-item right" @click="toShowPop">
				导入体检报告
			</button>
		</div>
		<Popup ref="reportPopup" :content="tipData" @confrim="toUpload" />
	</div>
</template>
<script type="text/javascript">
	import { getUrlParams } from "@/assets/js/until";
	import { jDomain } from "@/config/env.js";
	import { mapMutations } from "vuex";
	import { Toast } from "vant";
	import Popup from "./popup.vue";
	const stateList = [
		{
			value: 1,
			label: "解读中",
		},
		{
			value: 2,
			label: "解读完成",
		},
		{
			value: 3,
			label: "解读失败",
		},
	];
	export default {
		name: "UserReport",
		components: {
			Popup,
		},
		data() {
			return {
				stateList, // 解读状态列表
				imgUrl: require("@/assets/images/m-report/no-data.png"),
				pageNo: 1,
				pageSize: 10, //
				total: 0, // 总数
				loading: false, // 加载中
				finished: false, // 全部加载完成
				reportList: [], // 报告列表
				refreshing: false, // 下拉刷新
				flag: false, // 默认空白页标识
				tipData: {}, //弹框信息
			};
		},
		filters: {
			filterOptions(text, data) {
				return (
					data.find((item) => {
						if (text == item.value) {
							return item;
						}
					})?.label || text
				);
			},
		},
		computed: {
			finishedText() {
				return this.total > 8 ? "没有更多数据了" : "";
			},
		},
		methods: {
			...mapMutations(["setUserData"]),
			// pdf/图片 icon
			getImgUrl(type) {
				return type == 1
					? require("@/assets/images/m-report/pdf-icon.png")
					: require("@/assets/images/m-report/pic-icon.png");
			},
			// 跳转健康档案
			toJumpDoc() {
				window.location.href =
					jDomain +
					"/#/user/health-archive?appId=" +
					this.$store.state.account.userData.appId +
					"&profileId=" +
					this.$store.state.account.userData.profileId +
					"&appKey=" +
					this.$store.state.account.userData.appKey +
					"&timestamp=" +
					this.$store.state.account.userData.timestamp +
					"&userToken=" +
					encodeURIComponent(
						this.$store.state.account.userData.userToken
					) +
					"&from=" +
					this.$store.state.account.userData.from;
			},
			// 跳转报告详情
			toDetail(item) {
				localStorage.setItem("reportData", JSON.stringify(item));
				this.$router.push({
					name: "UserBodyReportDetail",
				});
			},
			// 分页加载数据
			onLoad() {
				// 数据全部加载完成
				if (this.reportList.length >= this.total) {
					this.finished = true;
					return;
				} else {
					this.loading = true;
					this.pageNo++;
					this.getData();
				}
			},
			// 加载数据
			onRefresh() {
				this.finished = false;
				setTimeout(() => {
					this.pageNo = 1;
					this.getData();
				}, 500);
			},
			// 数据请求
			async getData() {
				// 接口请求
				let params = {
					pageNo: this.pageNo,
					pageSize: this.pageSize,
					...this.userData,
				};
				let res = await this.axios.get(this.getApiUrl("reportList"), {
					params,
				});
				console.log(res.data);
				if (res.code === 1) {
					if (this.pageNo == 1) {
						this.reportList = res.data.data;
					} else {
						res.data.data.forEach((item) => {
							this.reportList.push(item);
						});
					}
					this.total = res.data.total;
				} else {
					Toast(res.msg);
				}
				this.refreshing = false; // 下拉刷新loading
				this.loading = false; // 上拉加载loading
				this.flag = true;
			},
			toShowPop() {
				this.tipData = {
					title: "温馨提示",
					msg: "为使您的健康档案更加准确，如您有多份体检报告需要上传，请按时间顺序先上传较早的报告，最后上传最新的报告。",
					confirmText: "开始上传",
				};
				this.$refs.reportPopup.show = true;
			},
			// 跳转上传报告页面
			toUpload() {
				this.$router.push({ path: "/user/body-report/import" });
			},
		},
		created() {
			document.title = "体检报告";
			let urlparams = getUrlParams(window.location.href);
			console.log(urlparams);
			if (urlparams.userToken) {
				console.log(urlparams);
				this.userData = urlparams;
				this.setUserData(urlparams);
			} else {
				this.userData = this.$store.state.account.userData;
			}
			this.getData();
		},
	};
</script>
<style lang="scss" scoped>
	@import "@/assets/css/function.scss";
	.report-wrap {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #f7f7f7;
		.tips {
			font-size: getsize(28px);
			width: 100%;
			padding-left: getsize(40px);
			box-sizing: border-box;
			height: getsize(88px);
			background: #ffefec;
			font-weight: bold;
			color: #f55c43;
			line-height: getsize(88px);
		}
		.no-data {
			padding-top: getsize(250px);
			text-align: center;
			.img-icon {
				width: getsize(260px);
				height: getsize(184px);
			}
			.desc {
				margin-top: getsize(48px);
				font-size: getsize(30px);
				color: #666666;
			}
		}
		.h-button {
			position: fixed;
			display: flex;
			justify-content: space-between;
			bottom: getsize(68px);
			left: 0;
			width: 100%;
			box-sizing: border-box;
			padding: 0 getsize(40px);
			z-index: 2;
			.btn-item {
				width: getsize(320px);
				height: getsize(98px);
				background: #ffffff;
				box-shadow: 0px getsize(6px) getsize(36px) getsize(-16px) #ffa395;
				border-radius: getsize(49px);
				font-size: getsize(36px);
				font-weight: bold;
				&.left {
					color: #f55c44;
				}
				&.right {
					color: #ffffff;
					background: linear-gradient(270deg, #f55b44 0%, #fa7519 100%);
				}
			}
		}
		.list-wrap {
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			bottom: getsize(196px);
			background-color: #f7f7f7;
			overflow-y: scroll;
			padding: 0 getsize(20px);
			-webkit-overflow-scrolling: touch;
			z-index: 1;
			.group-item {
				position: relative;
				display: flex;
				width: 100%;
				padding: getsize(57px) 0 getsize(50px) getsize(43px);
				box-sizing: border-box;
				min-height: getsize(200px);
				background-color: #ffffff;
				margin-top: getsize(20px);
				box-shadow: 0px 0px getsize(16px) 0px rgba(220, 220, 220, 0.3);
				border-radius: getsize(20px);
				color: #333333;
				font-size: getsize(30px);
				&.group-fail {
					padding-bottom: getsize(13px);
				}
				.group-item-icon {
					width: getsize(90px);
					height: getsize(90px);
					margin-right: getsize(20px);
				}
				.group-item-info {
					font-size: getsize(30px);
					p {
						padding-bottom: getsize(5px);
					}
					.fail-desc {
						color: #f55b44;
						font-size: getsize(22px);
					}
				}

				.group-state {
					position: absolute;
					right: 0;
					top: 0;
					display: flex;
					width: getsize(150px);
					height: getsize(50px);
					justify-content: center;
					align-items: center;
					font-size: getsize(26px);
					border-radius: 0px getsize(20px) 0px getsize(20px);
					color: #ffffff;
					&.running {
						background-color: #ff9f0e;
					}
					&.fail {
						background-color: #f55b44;
					}
					&.finish {
						background-color: #ececec;
						color: #999999;
					}
				}
			}
		}
	}
</style>
